/* eslint-disable */
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export async function exportElementToPDF(elementRef, filename = 'dokumen', onStart, onDone) {
  const original = elementRef?.current;
  if (!original) {
    alert('⚠️ Dokumen tidak ditemukan untuk di-export');
    return;
  }

  let cloneWrapper = null;

  try {
    if (onStart) onStart();

    // 1. Clone elemen aslinya (beserta semua isinya)
    const clone = original.cloneNode(true);

    // 2. Hapus elemen yang tidak boleh ikut ter-export dari CLONE
    clone.querySelectorAll('.no-export').forEach(el => el.remove());

    // 3. Kunci lebar clone ke lebar asli elemen SEBELUM lepas overflow.
    //    Jangan set width:'fit-content' — itu merusak grid berbasis fr (lihat KopFormulir).
    const originalWidth = original.scrollWidth || original.offsetWidth;
    clone.style.width = originalWidth + 'px';
    clone.style.maxWidth = 'none';

    // 4. Hanya lepas overflow pada elemen yang MEMANG punya scroll aktif
    //    (misal wrapper tabel dengan overflowX:auto), bukan semua elemen.
    clone.querySelectorAll('*').forEach(el => {
      const computed = window.getComputedStyle(el);
      if (computed.overflowX === 'auto' || computed.overflowX === 'scroll' ||
          computed.overflowY === 'auto' || computed.overflowY === 'scroll') {
        el.style.overflowX = 'visible';
        el.style.overflowY = 'visible';
        el.style.maxHeight = 'none';
      }
    });

    // 4. Bungkus clone dalam wrapper yang ditaruh di luar layar (bukan display:none, supaya tetap ter-render)
    cloneWrapper = document.createElement('div');
    cloneWrapper.style.position = 'fixed';
    cloneWrapper.style.top = '0';
    cloneWrapper.style.left = '-99999px';
    cloneWrapper.style.zIndex = '-1';
    cloneWrapper.style.background = 'white';
    cloneWrapper.appendChild(clone);
    document.body.appendChild(cloneWrapper);

    // Beri waktu browser reflow
    await new Promise(r => setTimeout(r, 80));

    const fullWidth = original.scrollWidth ;

    const canvas = await html2canvas(clone, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
      logging: false,
      width: fullWidth,
      windowWidth: fullWidth,
    });

    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth  = 210;
    const pageHeight = 297;

    const imgWidth  = pageWidth - 20;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position   = 10;

    pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    heightLeft -= (pageHeight - 20);

    while (heightLeft > 0) {
      position = heightLeft - imgHeight + 10;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
      heightLeft -= (pageHeight - 20);
    }

    pdf.save(`${filename}.pdf`);
  } catch (err) {
    console.error('Export PDF error:', err);
    alert('❌ Gagal export PDF: ' + err.message);
  } finally {
    if (cloneWrapper && cloneWrapper.parentNode) {
      cloneWrapper.parentNode.removeChild(cloneWrapper);
    }
    if (onDone) onDone();
  }
}